export default __webpack_public_path__ + "static/media/Inter-ExtraBold.30c3d891.woff";